<template>
  <div class="home-page">
    <!-- gamesnest.org_home_1 -->
    <AdSenseSlot
      ad-name="gamesnest.org_home_1"
      ad-slot="4493084829"
      placement="home-top"
    />
    <HeroSection />
    <NewsSection />
    <!-- gamesnest.org_home_2 -->
    <AdSenseSlot
      ad-name="gamesnest.org_home_2"
      ad-slot="1306998376"
      placement="home-news"
    />
    <ReviewsSection />
    <GuidesSection />
    <DealsSection />
    <GameHubsSection />
  </div>
</template>

<script>
import HeroSection from '@/components/home/HeroSection.vue'
import NewsSection from '@/components/home/NewsSection.vue'
import ReviewsSection from '@/components/home/ReviewsSection.vue'
import GuidesSection from '@/components/home/GuidesSection.vue'
import DealsSection from '@/components/home/DealsSection.vue'
import GameHubsSection from '@/components/home/GameHubsSection.vue'
import AdSenseSlot from '@/components/common/AdSenseSlot.vue'

export default {
  name: 'HomePage',
  components: {
    HeroSection,
    NewsSection,
    ReviewsSection,
    GuidesSection,
    DealsSection,
    GameHubsSection,
    AdSenseSlot,
  },
  async asyncData({ store }) {
    // Load all articles and game hubs for homepage
    await Promise.all([
      store.dispatch('articles/loadAllArticles'),
      store.dispatch('gameHubs/fetchGameHubs'),
    ])
  },
  metaInfo() {
    return {
      title: 'Gaming News, Reviews & Guides',
      meta: [
        {
          name: 'description',
          content: 'GamesNest - Your source for gaming news, reviews, guides and deals. Stay updated with the latest in gaming.',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.home-page {
  min-height: 100vh;
}
</style>
